<template>
	<v-container fluid class="pa-4" v-if="!loading && d">
		<h2 class="mb-4">Sistema di Gestione Integrato</h2>

		<!-- KPI cards -->
		<v-row>
			<v-col cols="12" sm="6" md="3">
				<v-card class="background-2 round-card" @click="go('compliancedocuments')" style="cursor:pointer">
					<v-card-text>
						<div class="d-flex align-center">
							<v-icon size="40" color="primary" class="mr-3">mdi-file-document-multiple-outline</v-icon>
							<div>
								<div class="text-h5">{{ d.documents.total }}</div>
								<div class="grey--text">Documenti</div>
							</div>
						</div>
						<div class="mt-2 caption">
							<span class="success--text">{{ d.documents.published }} pubblicati</span> ·
							<span class="orange--text">{{ d.documents.review_due }} in scadenza revisione</span>
						</div>
					</v-card-text>
				</v-card>
			</v-col>

			<v-col cols="12" sm="6" md="3">
				<v-card class="background-2 round-card" @click="go('compliancenonconformities')" style="cursor:pointer">
					<v-card-text>
						<div class="d-flex align-center">
							<v-icon size="40" color="error" class="mr-3">mdi-alert-octagon-outline</v-icon>
							<div>
								<div class="text-h5">{{ d.nonconformities.open }}</div>
								<div class="grey--text">NC aperte</div>
							</div>
						</div>
						<div class="mt-2 caption">
							<span class="red--text">{{ d.nonconformities.overdue }} scadute</span> ·
							{{ d.nonconformities.total }} totali
						</div>
					</v-card-text>
				</v-card>
			</v-col>

			<v-col cols="12" sm="6" md="3">
				<v-card class="background-2 round-card" @click="go('complianceaudits')" style="cursor:pointer">
					<v-card-text>
						<div class="d-flex align-center">
							<v-icon size="40" color="info" class="mr-3">mdi-clipboard-check-outline</v-icon>
							<div>
								<div class="text-h5">{{ d.audits.planned }}</div>
								<div class="grey--text">Audit pianificati</div>
							</div>
						</div>
						<div class="mt-2 caption">
							<span class="info--text">{{ d.audits.upcoming }} entro 30gg</span> ·
							{{ d.audits.total }} totali
						</div>
					</v-card-text>
				</v-card>
			</v-col>

			<v-col cols="12" sm="6" md="3">
				<v-card class="background-2 round-card" @click="go('compliancesoa')" style="cursor:pointer">
					<v-card-text>
						<div class="d-flex align-center">
							<v-icon size="40" color="success" class="mr-3">mdi-checkbox-multiple-marked-outline</v-icon>
							<div>
								<div class="text-h5">{{ d.soa.coverage_pct }}%</div>
								<div class="grey--text">Copertura SoA</div>
							</div>
						</div>
						<v-progress-linear class="mt-2" :value="d.soa.coverage_pct" color="success" height="6" rounded></v-progress-linear>
						<div class="mt-1 caption">{{ d.soa.implemented }}/{{ d.soa.applicable }} controlli implementati</div>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>

		<!-- KPI cards riga 2 -->
		<v-row v-if="d.objectives" class="mt-1">
			<v-col cols="12" sm="6" md="3">
				<v-card class="background-2 round-card" @click="go('complianceobjectives')" style="cursor:pointer">
					<v-card-text>
						<div class="d-flex align-center">
							<v-icon size="40" color="teal" class="mr-3">mdi-target-variant</v-icon>
							<div>
								<div class="text-h5">{{ d.objectives.active }}</div>
								<div class="grey--text">Obiettivi attivi</div>
							</div>
						</div>
						<div class="mt-2 caption">
							<span class="success--text">{{ d.objectives.achieved }} raggiunti</span> ·
							<span class="red--text">{{ d.objectives.overdue }} scaduti</span>
						</div>
					</v-card-text>
				</v-card>
			</v-col>

			<v-col cols="12" sm="6" md="3">
				<v-card class="background-2 round-card" @click="go('complianceincidents')" style="cursor:pointer">
					<v-card-text>
						<div class="d-flex align-center">
							<v-icon size="40" color="deep-orange" class="mr-3">mdi-flash-alert-outline</v-icon>
							<div>
								<div class="text-h5">{{ d.incidents.open }}</div>
								<div class="grey--text">Incidenti aperti</div>
							</div>
						</div>
						<div class="mt-2 caption">
							<span class="orange--text">{{ d.incidents.last30 }} ultimi 30gg</span> ·
							{{ d.incidents.total }} totali
						</div>
					</v-card-text>
				</v-card>
			</v-col>

			<v-col cols="12" sm="6" md="3">
				<v-card class="background-2 round-card" @click="go('compliancereviews')" style="cursor:pointer">
					<v-card-text>
						<div class="d-flex align-center">
							<v-icon size="40" color="purple" class="mr-3">mdi-clipboard-text-clock-outline</v-icon>
							<div>
								<div class="text-h5">{{ d.reviews.planned }}</div>
								<div class="grey--text">Riesami pianificati</div>
							</div>
						</div>
						<div class="mt-2 caption">
							Ultimo: <span class="info--text">{{ d.reviews.last_date || '—' }}</span>
						</div>
					</v-card-text>
				</v-card>
			</v-col>

			<v-col cols="12" sm="6" md="3">
				<v-card class="background-2 round-card" @click="go('compliancesupplierevaluations')" style="cursor:pointer">
					<v-card-text>
						<div class="d-flex align-center">
							<v-icon size="40" color="brown" class="mr-3">mdi-truck-check-outline</v-icon>
							<div>
								<div class="text-h5">{{ d.suppliers.qualified }}</div>
								<div class="grey--text">Fornitori qualificati</div>
							</div>
						</div>
						<div class="mt-2 caption">
							<span class="orange--text">{{ d.suppliers.reeval_due }} da rivalutare</span> ·
							{{ d.suppliers.evaluations }} valutazioni
						</div>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>

		<v-row class="mt-2">
			<!-- Risk heatmap -->
			<v-col cols="12" md="7">
				<v-card class="background-2 round-card">
					<v-card-title class="pa-3"><p class="pl-2 mb-0">Matrice dei rischi (probabilità × impatto)</p></v-card-title>
					<v-divider></v-divider>
					<v-card-text class="pa-4">
						<table class="heatmap">
							<tbody>
								<tr v-for="imp in [5,4,3,2,1]" :key="'i'+imp">
									<td class="axis">{{ imp }}</td>
									<td v-for="prob in [1,2,3,4,5]" :key="prob" class="cell"
										:style="{ backgroundColor: cellColor(prob*imp) }">
										{{ cellCount(prob, imp) || '' }}
									</td>
								</tr>
								<tr>
									<td class="axis"></td>
									<td v-for="prob in [1,2,3,4,5]" :key="'p'+prob" class="axis">{{ prob }}</td>
								</tr>
							</tbody>
						</table>
						<div class="mt-3 d-flex flex-wrap" style="gap:8px">
							<v-chip small dark color="#4caf50">Basso {{ d.risks.levels.basso }}</v-chip>
							<v-chip small dark color="#ff9800">Medio {{ d.risks.levels.medio }}</v-chip>
							<v-chip small dark color="#ff5722">Alto {{ d.risks.levels.alto }}</v-chip>
							<v-chip small dark color="#f44336">Critico {{ d.risks.levels.critico }}</v-chip>
						</div>
						<div class="mt-2 caption grey--text">Asse Y = impatto, asse X = probabilità. Numero = rischi nella cella.</div>
					</v-card-text>
				</v-card>
			</v-col>

			<!-- Riepilogo -->
			<v-col cols="12" md="5">
				<v-card class="background-2 round-card">
					<v-card-title class="pa-3"><p class="pl-2 mb-0">Riepilogo rischi</p></v-card-title>
					<v-divider></v-divider>
					<v-card-text class="pa-4">
						<div class="d-flex justify-space-between mb-2"><span>Rischi totali</span><strong>{{ d.risks.total }}</strong></div>
						<div class="d-flex justify-space-between mb-2"><span>Rischi aperti</span><strong>{{ d.risks.open }}</strong></div>
						<template v-if="d.context">
							<v-divider class="my-3"></v-divider>
							<div class="d-flex justify-space-between mb-2"><span>Fattori di contesto (SWOT)</span><strong>{{ d.context.issues }}</strong></div>
							<div class="d-flex justify-space-between mb-2"><span>Parti interessate</span><strong>{{ d.context.stakeholders }}</strong></div>
						</template>
						<v-divider class="my-3"></v-divider>
						<v-btn text color="primary" small @click="go('compliancerisks')">
							<v-icon left small>mdi-shield-alert</v-icon> Vai al registro rischi
						</v-btn>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	name: 'ComplianceDashboard',
	data() {
		return { loading: true, d: null }
	},
	created() { this.load() },
	methods: {
		load() {
			this.loading = true
			this.axios.get('compliancedashboard-info').then(r => {
				this.d = r.data.data
				this.loading = false
			}, () => { this.loading = false; this.$store.commit('setSnackbarError') })
		},
		go(name) {
			this.$router.push({ name: name + '-index' })
		},
		cellCount(prob, imp) {
			const c = this.d.risks.heatmap.find(h => h.probability === prob && h.impact === imp)
			return c ? c.count : 0
		},
		cellColor(score) {
			if (score <= 4) return 'rgba(76,175,80,0.55)'
			if (score <= 9) return 'rgba(255,152,0,0.55)'
			if (score <= 15) return 'rgba(255,87,34,0.6)'
			return 'rgba(244,67,54,0.7)'
		}
	}
}
</script>

<style scoped>
.heatmap { border-collapse: collapse; }
.heatmap td.cell {
	width: 56px; height: 48px; text-align: center; font-weight: 600;
	border: 1px solid rgba(150,150,150,0.25);
}
.heatmap td.axis {
	width: 28px; text-align: center; color: #999; font-size: 12px; padding: 2px 6px;
}
</style>
